import spacing from 'theme/config/spacing'

export default {
  root: {
    display: 'flex',
    alignContent: 'flex-start',
    margin: '0 !important'
  },
};
